/*
 *
 * File JS componente modal artists
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./modal-artists.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//
import Swiper from "swiper/bundle";

const modalArtists = () => {
    let modalArtists = document.querySelectorAll(".modal-artists");
    if (!modalArtists.length) return;

    modalArtists.forEach((el) => {
        let letters = new Swiper(el.querySelector(".slide-letters"), {
            slidesPerView: "auto",
            spaceBetween: 0,
            slideToClickedSlide: true,
            freeMode: true,
            speed: 700,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
        });

        let listArtists = new Swiper(el.querySelector(".slide-artists"), {
            slidesPerView: 1,
            spaceBetween: 0,
            simulateTouch: false,
            allowTouchMove: false,
            speed: 700,
            effect: "fade",
            thumbs: {
                swiper: letters,
            },
            fadeEffect: {
                crossFade: true,
            },
        });
    });
};

export default modalArtists;

//--------------------------------------------------------------------//
